module.exports = __webpack_public_path__ + "static/media/Framenotfound.05a31ce9.png";